/**
 * Colors an SVG icon with the brand color for a service or effect
 * @param svg - SVG template string
 * @param service - Uppload service object
 */
export var colorSVG = function colorSVG(svg, service) {
  return service.noRecolor ? svg : svg.replace(/#000/g, service.color || "#000");
};